import {
  MediaPostRequestMediaType,
  mediaPost
} from "@sportsgravyengineering/sg-api-react-sdk";
import axios from "axios";
export const uploadMediaUsingPresignedUrl = async (
  file: File,
  organizationId?: string
): Promise<string> => {
  try {
    const data = await mediaPost({
      mediaType: file.type.startsWith("image")
        ? MediaPostRequestMediaType.IMAGE
        : MediaPostRequestMediaType.VIDEO,
      mimeType: file.type,
      roleType: organizationId ? "ORGANIZATION" : "SYSTEM",
      roleTypeId: organizationId || "*"
    });
    console.log(data);
    const formData = new FormData();
    if (
      data.data?.uploadParams &&
      data.data?.uploadParams.url &&
      data.data?.uploadParams?.fields
    ) {
      const fields = data.data?.uploadParams?.fields;
      for (const key in fields) {
        formData.append(key, fields[key]);
      }

      formData.append("file", file);
      try {
        await axios.post(data.data?.uploadParams.url, formData);

        const mediaId = data.data?.uploadParams.fields["x-amz-meta-media-id"];
        console.log("DATS:", mediaId);
        if (mediaId) return Promise.resolve(mediaId);
        else return Promise.reject(new Error("upload not successful"));
      } catch (error) {
        //enqueueSnackbar("Failed to upload!", { variant: "error" });
        console.log("ERR");
        return Promise.reject(new Error("Failed to Upload"));
      }
    }
    return Promise.reject(new Error("Upload Failed"));
  } catch (err) {
    console.log(err);
    return Promise.reject(new Error("upload not successful"));
  }
};
